import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@src/lib/ui/Dialog";
import { FC } from "react";
import { Button } from "@src/lib/ui/Button";
import Spinner from "@src/lib/ui/Spinner";
import { gql } from "@apollo/client";
import { useRoleDialogBody_RolesQuery } from "./RoleDialogBody.generated";
import RoleDialogContent, { RoleDialogContentProps } from "./RoleDialogContent";

type Props = RoleDialogContentProps & {
  title: string;
  saveCopy: string;
  onClose: () => void;
  onSave: () => void;
  loading: boolean;
  saveDisabled: boolean;
};

const RoleDialogBody: FC<Props> = ({
  title,
  saveCopy,
  onClose,
  onSave,
  loading,
  saveDisabled,
  ...contentProps
}) => {
  const { loading: rolesLoading } = useRoleDialogBody_RolesQuery();

  if (rolesLoading) {
    return (
      <DialogContent className="flex h-[80vh] min-w-[975px] flex-col gap-0 overflow-hidden p-0">
        <DialogHeader className="shrink-0 border-b border-border p-6">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-1 items-center justify-center p-6">
          <Spinner />
        </div>
      </DialogContent>
    );
  }

  return (
    <DialogContent className="flex h-[80vh] min-w-[975px] flex-col gap-0 overflow-hidden p-0">
      <DialogHeader className="shrink-0 border-b border-border p-6">
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <RoleDialogContent {...contentProps} />
      <DialogFooter className="shrink-0 border-t border-border p-4">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={saveDisabled || loading}
          onClick={onSave}
          loading={loading}
        >
          {saveCopy}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};

gql`
  fragment RoleDialogBody_Role on Role {
    id
    name
    userCount
    roleLevelV2
    roleActionPermissions {
      roleUserType
    }
  }
  query RoleDialogBody_Roles {
    Roles {
      objects {
        ...RoleDialogBody_Role
      }
    }
  }
`;

export default RoleDialogBody;
